import { Component, OnInit, Input } from '@angular/core';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import moment from "moment-timezone";
import { ConstantsService } from "../../services/constants/constants.service";
import { AlertBannerService, AlertType } from "../../lib/alert-banner";
import { SurveyService } from "../../services/survey/survey.service";
import { ProfileService } from "../../services/profile/profile.service";
import { LearnMoreUaModalComponent } from "./components/learn-more-ua-modal/learn-more-ua-modal.component";
import { BsModalService } from "ngx-bootstrap/modal";
import { EditResolutionModalComponent } from "./components/edit-resolution-modal/edit-resolution-modal.component";
import { OrganisationService } from "../../services/organisation/organisation.service";
import { ReferenceSummaryService, Area, FeedbackType } from "../../services/reference-summary";
import { AiSettingsService, AiSettingsResponse } from 'src/app/services/ai-settings/ai-settings.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-reference-report-content',
  templateUrl: './reference-report-content.component.pug',
  styleUrls: ['./reference-report-content.component.scss'],
  standalone: false
})
export class ReferenceReportContentComponent implements OnInit {
    @Input() data: any;
    @Input() checkId: any;
    candidate: any;
    referee: any;
    competencies: any;
    competenciesStats: any = {};
    competenciesMetaData = ConstantsService.CORE_COMPETENCIES_META_DATA;
    timeline: any;
    attachments: any;
    optIn: any;
    optData = ConstantsService.REFEREE_OPT_IN_OUT_DATA
    candidateFlag = false;
    wordCountStats: any = {};
    wordCountData: any = {};
    coverage_start_date: any;
    coverage_end_date: any;
    employementLength: any;
    coverage_difference: any;
    position: any;
    stats: any;
    candidateDetailSubheading: string = '';
    workplaceLabel: string = '';
    courseOrRoleLabel: string = '';
    candidateStartFieldLabel: string = '';
    candidateEndFieldLabel: string = '';
    candidateLengthLabel: string = '';
    activityStatus;
    orgName = ''
    turnaroundStats: any = {};
    turnaroundData: any = {};
    metaData = ConstantsService.REFEREE_DETAILS_META_DATA;
    refereeFeedbackMetaData = {
        heading: $localize`Referee feedback`,
        description: $localize`The referee’s responses to the reference survey.`,
        additionalResponse: $localize`Additional response`,
        confirmationHeading: '',
        confirmationDescription: '',
        words: $localize`Words`,
        avg: $localize`Avg.`,
    };

    candidateDetailsData = {}

    refereeModificationsData = {
        label: $localize`Referee modifications`,
        description: $localize`Changes made to the details originally provided.`
    };
    refereeSentimentData = ConstantsService.REFEREE_SENTIMENT_DATA

    unusualActivityData = ConstantsService.UNUSUAL_ACTIVITY_DATA;
    candidateName = '';
    feedbackCoverage = '';
    coverage = '';
    coverageOffset = '';
    feedbackCoverageOffset = '';
    coverageDates = '';
    feedbackDates = '';
    totalWorkHistoryDates = '';

    coverageData = {
        heading: $localize`Reference coverage`,
        subHeading: $localize`Feedback covers the entire or part of the time spent at the organisation.`,
        legendItem1: $localize`Total work history`,
        legendItem2: $localize`Employed at `,
        legendItem3: $localize`Feedback covers`
    };

    coveragePercentageStats = {
        coverageOffset: this.coverageOffset,
        coverage: this.coverage,
        feedbackCoverageOffset: this.feedbackCoverageOffset,
        feedbackCoverage: this.feedbackCoverage
    };

    notes: any = [];
    note = '';
    private bsModalRef: any;
    author = "";
    currentUser = "";
    status = "detected";
    employmentStartDate = ""
    employmentEndDate = "";
    refereeDetailSubheading: string = '';
    earliestTimelineDate: string = '';
    latestTimelineDate: string = '';
    candidateCoverage: any;

    attachmentsMetaData = {
        heading: $localize`Attachments`,
        subheading: $localize`Supporting documents uploaded by the referee.`,
        column: {
            file: $localize`File`,
            description: $localize`Description`,
            uploadedOn: $localize`Uploaded on`,
            download: $localize`Download`,
        }
    };

    candidateResponseData = {
        heading: 'Candidate responses',
        additionalResponse: 'Additional response',
        confirmationHeading: 'Candidate confirmation',
        confirmationDescription: 'I confirm that all the above information and details I have provided in this document are accurate and true.',
        words: '',
        avg: '',
    };
    updated_candidateResponseData = {
        heading: $localize `Candidate responses`,
        additionalResponse: $localize `Additional response`,
        confirmationHeading: $localize`Candidate confirmation`,
        confirmationDescription: $localize`I have obtained the consent of my references to submit their data in relation to this request.`,
        words: '',
        avg: '',
    };


    referenceCoverageSubheading: string = '';
    employedAtDescription: string = '';
    orgBrandName: any;
    more_questions = true;
    confirmation_question = false;

    // Reference Summary properties
    referenceSummary: string = '';
    areasOfStrength: Area[] = [];
    areasOfImprovement: Area[] = [];
    areasOfNote: Area[] = [];
    feedback: FeedbackType = FeedbackType.Neutral;
    refereeCount: number = 1;
    currentUserUid: string = '';
    referenceSummaryId: number | null = null;
    aiSummaryEnabled = false;
    private aiSettingsSubscription?: Subscription;

    constructor(private permissions: PermissionsService, public surveyService: SurveyService,
        private profile: ProfileService,
        public alertList: AlertBannerService, public modalService: BsModalService,
        private orgService: OrganisationService,
        private referenceSummaryService: ReferenceSummaryService,
        private aiSettingsService: AiSettingsService) {
    }


    ngOnInit(): void {
        this.orgBrandName = this.orgService.getOrganisationBrandName()
        // Load user profile details to get currentUserId and subscribe to AI settings
        this.getProfileDetails();
        this.aiSettingsSubscription = this.aiSettingsService.aiSettings$.subscribe({
            next: (settings: AiSettingsResponse | null) => {
                this.aiSummaryEnabled = settings?.config?.summary ?? false;
            },
            error: (error) => {
                console.error('Error loading AI settings for reference report:', error);
                this.aiSummaryEnabled = false;
            }
        });
        // Initial load of AI settings
        this.aiSettingsService.getAiSettings().subscribe();
        if (this.data) {
            this.candidate = this.data['candidate'];
            this.candidateResponseSection();
            this.referee = this.data['referee'];
            this.timeline = this.data['timeline'];
            this.competencies = this.data['competencies'];
            this.attachments = this.data['attachments'];
            this.optIn = this.data['opt_in'];


            this.notes = this.referee.unusual_activity?.notes
            this.orgName = this.orgService.getOrganisationBrandName();
            this.candidateName = this.data.candidate.name;
            this.totalWorkHistoryDates = this.format_date(this.timeline.earliest_timeline_date) + ' - ' + this.format_date(this.timeline.latest_timeline_date);
            this.coverageDates = this.format_date(this.timeline.referee_start_date) + ' - ' + this.format_date(this.timeline.referee_end_date);
            this.feedbackDates = this.format_date(this.timeline.coverage_start_date) + ' - ' + this.format_date(this.timeline.coverage_end_date);
            this.coverage_start_date = this.format_date(this.timeline.coverage_start_date);
            this.coverage_end_date = this.format_date(this.timeline.coverage_end_date);
            this.employementLength = this.calculateCoverageDifference(this.timeline.referee_start_date, this.timeline.referee_end_date);
            this.coverage_difference = this.calculateCoverageDifference(this.timeline.coverage_start_date, this.timeline.coverage_end_date);
            this.employmentStartDate = this.format_date(this.timeline.referee_start_date);
            this.employmentEndDate = this.format_date(this.timeline.referee_end_date);

            this.updated_candidateResponseData["description"] = this.orgBrandName +$localize`\'s initial questions to candidates.`;

            this.prepareReferenceCoverageDetails()
            this.initializeCoverageData()
            this.calculateCoverageDates();
            this.buildUnusualActivityData()
            this.initAttachmentDates();

            if (this.referee) {
                this.position = this.referee.position
                this.stats = this.referee['stats'];
                this.initializeTurnaroundStatsScoreAndData();
                this.applyTurnaroundTimeCustomStyling();
                this.calculateTurnaroundTimeUnit();
                this.initializeWordCountStatsAndData();
                this.applyWordCountCustomStyling();

            }

            if (this.competencies) {
                this.competenciesStats.score = this.competencies?.candidate_score?.toFixed(1);
                this.competenciesStats.average = this.competencies?.overall_average?.toFixed(1);
                this.manageColorFont();
            }
            if (this.timeline) {
                this.prepareLabels();
                this.initCandidateDetails();
            }

            this.loadReferenceSummary();

        }
    }

    ngOnDestroy(): void {
        if (this.aiSettingsSubscription) {
            this.aiSettingsSubscription.unsubscribe();
        }
    }

        initAttachmentDates() {
        if (this.attachments) {
            this.attachments.forEach(value => {
                value.created_date = moment(value.created_date).format('MMM DD, YYYY');
            })
        }
    }

    loadReferenceSummary() {
        if (this.checkId && this.candidate?.id && this.referee?.id) {
            const ua_identified = this.referee?.unusual_activity?.status === 'detected';
            const mas_identified = this.referee?.unusual_activity?.status === 'suspicious';

            // Extract reference summary from data input instead of making API call
            const transformedData = this.referenceSummaryService.extractReferenceSummaryFromCheck(this.data);

            if (transformedData) {
                this.referenceSummaryId = transformedData.id;
                this.referenceSummary = transformedData.summary;
                this.areasOfStrength = transformedData.areasOfStrength;
                this.areasOfImprovement = transformedData.areasOfImprovement;
                this.areasOfNote = transformedData.areasOfNote;
                this.feedback = transformedData.feedback;
                this.refereeCount = transformedData.refereeCount;

                // Append Areas of Note based on unusual activity flags
                if (ua_identified) {
                    this.areasOfNote = [
                        ...this.areasOfNote,
                        {
                            title: $localize`Unusual activity detected`,
                            desc: $localize`There have been one or more unusual activity events detected.`
                        } as Area
                    ];
                }

                if (mas_identified) {
                    this.areasOfNote = [
                        ...this.areasOfNote,
                        {
                            title: $localize`Marked as suspicious`,
                            desc: $localize`Unusual activity events have been detected and marked as suspicious by your team.`
                        } as Area
                    ];
                }
            } else {
                console.warn('Reference summary not found in data');
            }
        }
    }

    onUserFeedback(feedback: FeedbackType) {
        this.feedback = feedback;

        // Call the service to save user feedback
        if (this.checkId && this.currentUserUid && this.referenceSummaryId) {
            this.referenceSummaryService.setUserFeedback(
                this.checkId,
                this.referenceSummaryId,
                this.currentUserUid,
                feedback
            ).subscribe({
                next: (response) => {
                    // User feedback saved successfully
                },
                error: (error) => {
                    console.error('Error saving user feedback:', error);
                }
            });
        }
    }

    candidateResponseSection(){
      const answers = this.candidate.answers;
      const len = answers.length;
      const lastIndex = len - 1;
      const firstQuestion = answers[0]?.question;
      const lastQuestion = answers[lastIndex]?.question;

      const isSpecificQuestion = (question: string) =>
          question === "I have obtained the consent of my references to submit their data in relation to this request." ||
          question === "I confirm that all the above information and details I have provided in this document are accurate and true";

      if (len === 1 && isSpecificQuestion(firstQuestion)) {
          this.more_questions = false;
      } else if (isSpecificQuestion(lastQuestion)) {
          this.candidate.answers = answers.slice(0, lastIndex);
      }
    }

    prepareReferenceCoverageDetails() {
        switch (this.candidate?.verb) {
            case 'Employed at':
                this.referenceCoverageSubheading = $localize`Feedback covers the entire or part of the time spent at the organisation.`;
                this.employedAtDescription = $localize`Employed at ${this.referee?.organisation}`
                break;
            case 'Character reference':
                this.referenceCoverageSubheading = $localize`Feedback covers the time that they have known each other.`;
                this.employedAtDescription = $localize`Relationship`
                break;
            case 'Studied at':
                this.referenceCoverageSubheading = $localize`Feedback covers the entire or part of the time spent at the institution.`;
                this.employedAtDescription = $localize`Studied at ${this.referee?.organisation}`
                break;
            case 'Volunteered with':
                this.referenceCoverageSubheading = $localize`Feedback covers the entire or part of the time spent at the organisation.`;
                this.employedAtDescription = $localize`Volunteered with ${this.referee?.organisation}`

        }
    }

    initializeCoverageData() {
        this.coverageData = {
            heading: $localize`Reference coverage`,
            subHeading: this.referenceCoverageSubheading,
            legendItem1: $localize`Total work history`,
            legendItem2: this.employedAtDescription,
            legendItem3: $localize`Feedback covers`
        };
    }

    manageColorFont() {
        if (this.competenciesStats.average <= this.competenciesStats.score) {
            this.competenciesMetaData.average_background_color = '#E0EAE7';
            this.competenciesMetaData.score_background_color = '#32735f';
            this.competenciesMetaData.score_font_color = '#FFFFFF';
            this.competenciesMetaData.average_font_color = '#32735f';
            this.competenciesMetaData.average_value_font_color = '#2B6251';
        }
    }

    showLearnMoreModal() {
        this.bsModalRef = this.modalService.show(LearnMoreUaModalComponent, {
            class: 'modal-dialog-centered modal-lg'
        });
    }

    prepareLabels() {
        switch (this.candidate?.verb) {
            case 'Volunteered with':
            case 'Employed at':
                this.candidateDetailSubheading = $localize`Includes date of employment.`;
                this.refereeDetailSubheading = $localize`Feedback coverage is the shared period of employment.`;
                this.workplaceLabel = $localize`Organisation`;
                this.courseOrRoleLabel = $localize`Role`;
                this.candidateStartFieldLabel = $localize`Employment start date`;
                this.candidateEndFieldLabel = $localize`Employment end date`;
                this.candidateLengthLabel = $localize`Employment length`;
                break;
            case 'Character reference':
                this.candidateDetailSubheading = $localize`Includes period of relationship.`;
                this.refereeDetailSubheading = $localize`Feedback coverage refers to the period of the relationship.`;
                this.workplaceLabel = $localize`Relationship`;
                this.courseOrRoleLabel = '';
                this.candidateStartFieldLabel = $localize`Relationship start date`;
                this.candidateEndFieldLabel = $localize`Relationship end date`;
                this.candidateLengthLabel = $localize`Relationship length`;
                break;
            case 'Studied at':
                this.candidateDetailSubheading = $localize`Includes period of study.`
                this.refereeDetailSubheading = $localize`Feedback coverage refers to the shared period of study.`;
                this.workplaceLabel = $localize`Institution`;
                this.courseOrRoleLabel = $localize`Course`;
                this.candidateStartFieldLabel = $localize`Course start date`;
                this.candidateEndFieldLabel = $localize`Course end date`;
                this.candidateLengthLabel = $localize`Course length`;
                break;
            default:
                this.candidateDetailSubheading = $localize`Includes date of employment.`;
                this.refereeDetailSubheading = $localize`Feedback coverage refers to the shared period of study.`;
                this.workplaceLabel = $localize`Organisation`;
                this.courseOrRoleLabel = $localize`Role`;
                this.candidateStartFieldLabel = $localize`Employment start date`;
                this.candidateEndFieldLabel = $localize`Employment end date`;
                this.candidateLengthLabel = $localize`Employment length`;
                break;
        }
    }

    initCandidateDetails() {
        this.earliestTimelineDate = this.format_date(this.timeline.earliest_timeline_date);
        this.latestTimelineDate = this.format_date(this.timeline.latest_timeline_date);
        this.candidateCoverage = this.calculateCoverageDifference(this.timeline.referee_start_date, this.timeline.referee_end_date);
        this.candidateDetailsData = {
            heading: $localize`Candidate details`,
            description: this.candidateDetailSubheading,
            fieldNamesCol1: [$localize`Candidate name`, this.workplaceLabel, this.courseOrRoleLabel],
            fieldNamesCol2: [$localize`Email address`, $localize`Phone`],
            fieldNamesCol3: [this.candidateStartFieldLabel, this.candidateEndFieldLabel, this.candidateLengthLabel],
        }
    }

    calculateCoverageDifference(timeline_1, timeline_2) {
        let start_date = moment(timeline_1.year + '-' + timeline_1.month + '-' + timeline_1.day, "YYYY-MM-DD");
        let end_date = moment(timeline_2.year + '-' + timeline_2.month + '-' + timeline_2.day, "YYYY-MM-DD");
        let years = 0;
        let months = 0;
        years = end_date.diff(start_date, "years")
        start_date.add(years, 'years');
        months = end_date.diff(start_date, "months");
        let string_duration = '';

        if (years > 1) {
            string_duration = years + ' ' + $localize`years` + ' ';
        } else if (years == 1) {
            string_duration = years + ' ' + $localize`year` + ' ';
        }
        if (months > 1) {
            string_duration += months + ' ' + $localize`months`;
        } else if (months == 1) {
            string_duration += months + ' ' + $localize`month`;
        } else if (years === 0 && months === 0) {
            string_duration = '0 ' + $localize`months`;
        }
        return string_duration;
    }

    getProfileDetails(): any {
        // Get user ID from permissions service
        this.currentUserUid = this.permissions.data?.user?.uid || '';

        // Get username from profile service
        this.profile.getProfile().subscribe(data => {
            this.currentUser = data['first_name'] + ' ' + data['last_name'];
            if (!this.author) {
                this.author = this.currentUser;
            }
        }, error => {
            console.error('Error loading profile:', error);
            this.alertList.append([{
                type: AlertType.DANGER,
                message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
                keepOnRouteChange: true
            }]);
        });
    }


    onAddNote($event) {
        this.surveyService.addUnusualActivityNote(this.checkId, this.referee['id'], $event.note)
            .subscribe(
                () => {
                    this.notes.unshift({
                        'comment': $event.note,
                        'updated': new Date(),
                        'employer_name': this.currentUser,
                    });

                },
                () => {
                    this.alertList.append([{
                        active: true,
                        type: AlertType.DANGER,
                        message: 'Oops! Something went wrong. Our developers have been notified. Feel free to try again.'
                    }]);
                }
            );
    }

    format_date(date_dict: any, locale: string = "") {
        return moment(date_dict.year + '-' + date_dict.month + '-' + date_dict.day, "YYYY-MM-DD").locale(locale).format('DD MMM YYYY');
    }

    calculateCoverageDates() {
        let earliest_date = '', latest_date = '', coverage_start_date = '', coverage_end_date = '',
            feedback_start_date = '', feedback_end_date = '';

        earliest_date = this.format_date(this.timeline.earliest_timeline_date, 'en');
        latest_date = this.format_date(this.timeline.latest_timeline_date, 'en');

        coverage_start_date = this.format_date(this.timeline.referee_start_date, 'en');
        coverage_end_date = this.format_date(this.timeline.referee_end_date, 'en');

        feedback_start_date = this.format_date(this.timeline.coverage_start_date, 'en');
        feedback_end_date = this.format_date(this.timeline.coverage_end_date, 'en');


        if (coverage_start_date == feedback_start_date && feedback_end_date == coverage_end_date) {
            this.feedbackCoverage = '100';
        } else {
            this.feedbackCoverage = String(this.calculateDifference(feedback_start_date, feedback_end_date) * 100 / this.calculateDifference(coverage_start_date, coverage_end_date));
        }
        this.coverage = String(this.calculateDifference(coverage_start_date, coverage_end_date) * 100 / this.calculateDifference(earliest_date, latest_date));

        this.coverageOffset = String(this.calculateDifference(earliest_date, coverage_start_date) * 100 / this.calculateDifference(earliest_date, latest_date));
        if (coverage_start_date == feedback_start_date) {
            this.feedbackCoverageOffset = '0';
        } else {
            this.feedbackCoverageOffset = String(this.calculateDifference(coverage_start_date, feedback_start_date) * 100 / this.calculateDifference(coverage_start_date, coverage_end_date));
        }
        this.coveragePercentageStats = {
            coverageOffset: this.coverageOffset,
            coverage: this.coverage,
            feedbackCoverageOffset: this.feedbackCoverageOffset,
            feedbackCoverage: this.feedbackCoverage
        };
    }

    calculateDifference(startDate, endDate) {
        var start = new Date(startDate);
        var end = new Date(endDate);
        return Math.floor((end.getTime() - start.getTime()) / 1000 / 60 / 60 / 24);
    }


    initializeTurnaroundStatsScoreAndData(): void {
        this.turnaroundData.heading = $localize`Turnaround Time`;
        this.turnaroundData.subheading = $localize`The total time taken by a referee to submit feedback.`;
        this.turnaroundData.label_2 = $localize`Average`;
        this.turnaroundData.label_3 = $localize`Referee`;
        this.turnaroundStats.average = this.stats?.turnaround_average ?? 0;
        this.turnaroundStats.score = this.stats?.turnaround ?? 0;
    }

    applyTurnaroundTimeStyling(): void {
        if (this.turnaroundStats.average >= this.turnaroundStats.score) {
            this.setTurnaroundTimeBackgroundColor('#E0EAE7');
            this.setTurnaroundTimeScoreBackgroundColor('#32735f');
            this.setTurnaroundTimeScoreFontColor('#FFFFFF');
            this.setTurnaroundTimeAverageFontColor('#32735f');
            this.setTurnaroundTimeAverageValueFontColor('#2B6251');
        } else {
            this.setTurnaroundTimeBackgroundColor('#FBF2E5');
            this.setTurnaroundTimeAverageValueFontColor('#d18400');
            this.setTurnaroundTimeAverageFontColor('#d18400');
            this.setTurnaroundTimeScoreFontColor('#FFFFFF');
            this.setTurnaroundTimeScoreBackgroundColor('#d18400');
        }
    }
     applyTurnaroundTimeCustomStyling(): void {
       if (this.turnaroundStats.average >= this.turnaroundStats.score) {
         this.turnaroundData.averageCheckType = 3;
         this.turnaroundData.averageScoreType = 4;
       } else {
         this.turnaroundData.averageCheckType = 3;
         this.turnaroundData.averageScoreType = 4;
       }
     }

    calculateTurnaroundTimeUnit(): void {
        this.turnaroundData.average_unit = this.stats?.turnaround_average === 1 ? $localize`hour` : $localize`hours`;
        this.turnaroundData.unit = this.stats?.turnaround === 1 ? $localize`hour` : $localize`hours`;
    }

    setTurnaroundTimeBackgroundColor(color: string): void {
        this.turnaroundData.average_background_color = color;
    }

    setTurnaroundTimeAverageFontColor(color: string): void {
        this.turnaroundData.average_font_color = color;
    }

    setTurnaroundTimeAverageValueFontColor(color: string): void {
        this.turnaroundData.average_value_font_color = color;
    }

    setTurnaroundTimeScoreFontColor(color: string): void {
        this.turnaroundData.score_font_color = color;
    }

    setTurnaroundTimeScoreBackgroundColor(color: string): void {
        this.turnaroundData.score_background_color = color;
    }

    initializeWordCountStatsAndData(): void {
        this.wordCountData.heading = $localize`Word count`;
        this.wordCountData.subheading = $localize`Indication of feedback content provided by the referee.`;
        this.wordCountData.label_2 = $localize`Average`;
        this.wordCountData.label_3 = $localize`Referee`;
        this.wordCountStats.score = this.stats?.word_count ?? 0;
        this.wordCountStats.average = this.stats?.word_count_average ?? 0;
    }

    applyWordCountStyling(): void {
        if (this.wordCountStats.average <= this.wordCountStats.score) {
            this.setWordCountAverageStyling(true);
        } else {
            this.setWordCountAverageStyling(false);
        }
    }
     applyWordCountCustomStyling(): void {
        if (this.wordCountStats.average <= this.wordCountStats.score) {
            this.setWordCountAverageCustomStyling(true);
        } else {
            this.setWordCountAverageCustomStyling(false);
        }
    }

    setWordCountAverageStyling(isAverageLessOrEqualToCount: boolean): void {
        if (isAverageLessOrEqualToCount) {
            this.setWordCountAverageBackgroundColor('#E0EAE7');
            this.setWordCountScoreBackgroundColor('#32735f');
            this.setWordCountScoreFontColor('#FFFFFF');
            this.setWordCountAverageFontColor('#32735f');
            this.setWordCountAverageValueFontColor('#2B6251');
        } else {
            this.setWordCountAverageBackgroundColor('#FBF2E5');
            this.setWordCountAverageFontColor('#d18400');
            this.setWordCountAverageValueFontColor('#d18400');
            this.setWordCountScoreFontColor('#FFFFFF');
            this.setWordCountScoreBackgroundColor('#d18400');
        }
    }
    setWordCountAverageCustomStyling(isAverageLessOrEqualToCount: boolean): void {
        if (isAverageLessOrEqualToCount) {
            this.wordCountData.averageCheckType = 1;
            this.wordCountData.averageScoreType = 2;
        } else {
            this.wordCountData.averageCheckType = 1;
            this.wordCountData.averageScoreType = 2;
        }
    }


    setWordCountAverageBackgroundColor(color: string): void {
        this.wordCountData.average_background_color = color;
    }

    setWordCountAverageFontColor(color: string): void {
        this.wordCountData.average_font_color = color;
    }

    setWordCountAverageValueFontColor(color: string): void {
        this.wordCountData.average_value_font_color = color;
    }

    setWordCountScoreFontColor(color: string): void {
        this.wordCountData.score_font_color = color;
    }

    setWordCountScoreBackgroundColor(color: string): void {
        this.wordCountData.score_background_color = color;
    }

    editStatus() {
        let initialState = {
            "checkId": this.checkId,
            "refereeId": this.referee["id"]
        };
        this.bsModalRef = this.modalService.show(EditResolutionModalComponent, {
            class: 'modal-dialog-centered', initialState
        });
        this.bsModalRef.content?.statusChange?.subscribe(($e) => {
            this.status = $e;
            this.referee.unusual_activity.status = this.status;
        })
    }


    addStatus(resolution: number) {
        this.surveyService.addUnusualActivityResolution(this.checkId, this.referee['id'], resolution).subscribe(
            (res) => {
                if (resolution === 1) {
                    this.status = 'suspicious';
                } else {
                    this.status = 'valid';
                    this.referee.unusual_activity.status = this.status;
                }
            },
            (err) => {
                this.alertList.append([{
                    active: true,
                    type: AlertType.DANGER,
                    message: 'Oops! Something went wrong. Our developers have been notified. Feel free to try again.'
                }]);
            }
        );
    }

    buildUnusualActivityData(): void {
        this.unusualActivityData["unusual_ip_note"] = $localize`${this.candidate?.name} and ${this.referee?.name} accessed Xref from the same IP address (meaning both the candidate and referee appear to have been at the same location using the same internet connection).`,
            this.unusualActivityData["unusual_email_note"] = $localize`${this.referee.name} completed the reference request using a personal (non-professional) email address (gmail.com).`;
        this.unusualActivityData["unusual_browser_note"] = $localize`${this.candidate?.name} and ${this.referee?.name} used the same operating system and internet browser to access Xref.`;
        this.unusualActivityData["unusual_phone_note"] = $localize`${this.candidate?.name} and ${this.referee?.name} have the same phone number.`,
            this.unusualActivityData["unusual_mobile_note"] = $localize`${this.referee?.name} has the same phone number as at least one other referee provided by ${this.candidate?.name}.`
    }

    onDownloadAttachmentEvent($event) {
        this.surveyService.downloadRefereeAttachment(this.checkId, $event.attachmentId, $event.fileName, undefined, () => {
            this.alertList.append([{ active: true, type: AlertType.DANGER, message: 'Oops! Something went wrong. Our developers have been notified. Feel free to try again.' }]);
        });
    }
}
